import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';

import { ApiBaseContract } from './base';

export class ApiContractMisc extends ApiBaseContract {
  @ApiOptions({ interceptErrors: false })
  getCurrencyCodeByCountryCode(countryCode: string) {
    return this.get(`/misc/country`, new DefaultParams({ code: countryCode }));
  }
}
